import { Box, Skeleton, Theme } from '@mui/material';
import { inputFiled, StyledFormWrapper } from '../pages/style';

type PDFReportFormSkeltonProps = {
  gridLayout: string;
  theme: Theme;
  isMobile: boolean;
  isTablet: boolean;
  isExtraLarge: boolean;
};
export const PDFReportFormSkelton = ({
  gridLayout,
  theme,
  isMobile,
  isTablet,
  isExtraLarge,
}: PDFReportFormSkeltonProps) => (
  <StyledFormWrapper
    theme={theme}
    isTablet={isTablet}
    isExtraLarge={isExtraLarge}
    isPdfReport={false}
  >
    <Box width="100%" sx={{ mb: 10 }}>
      <Box display="grid" gridTemplateColumns={gridLayout} gap={3}>
        {[...Array(8)].map((_, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            height={30}
            sx={{ borderRadius: 1, ...inputFiled }}
          />
        ))}
      </Box>
    </Box>
  </StyledFormWrapper>
);
